import { useRef } from 'react'
import { type GroupPricingResult } from '../groupCheckoutPricing.types'
import { useGroupCheckoutPricing } from './useGroupCheckoutPricing'

// The group-pricing query key changes on every cart/promo/address edit, dropping
// `data` mid-refetch. Discount surfaces read pricing through this hook so they
// hold the last known result together instead of flickering out one by one.
export function useLastGroupPricing(): GroupPricingResult | null {
  const groupPricingResult = useGroupCheckoutPricing()
  const lastExistingGroupPricing = useRef<GroupPricingResult | null>(null)
  if (groupPricingResult.data) {
    lastExistingGroupPricing.current = groupPricingResult.data
  }
  return lastExistingGroupPricing.current
}
